import { getLocalBookingDateString } from "./BookingDateUtils";

const getBookingEventDateKey = (event) => {
  const startValue = event && event.start;

  if (!startValue) {
    return "";
  }

  if (typeof startValue === "string") {
    return startValue.slice(0, 10);
  }

  if (startValue.toDate) {
    return getLocalBookingDateString(startValue.toDate());
  }

  return getLocalBookingDateString(startValue);
};

export const countBookingEventsByDate = (events = [], statuses = []) => {
  const statusSet = new Set(statuses);

  return events.reduce((acc, event) => {
    const status = (event.extendedProps && event.extendedProps.status) || "";

    if (statusSet.has(status)) {
      const dateKey = getBookingEventDateKey(event);

      if (dateKey) {
        acc[dateKey] = (acc[dateKey] || 0) + 1;
      }
    }

    return acc;
  }, {});
};
